var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniOrderUnassigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "15px",
    viewBox: "0 0 13 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0.288675135 L12.4951905,3.46132487 C12.8045916,3.63995766 12.9951905,3.97008468 12.9951905,4.32735027 L12.9951905,10.6726497 C12.9951905,11.0299153 12.8045916,11.3600423 12.4951905,11.5386751 L7,14.7113249 C6.69059892,14.8899577 6.30940108,14.8899577 6,14.7113249 L0.504809472,11.5386751 C0.195408395,11.3600423 0.00480947162,11.0299153 0.00480947162,10.6726497 L0.00480947162,4.32735027 C0.00480947162,3.97008468 0.195408395,3.63995766 0.504809472,3.46132487 L6,0.288675135 C6.30940108,0.11004234 6.69059892,0.11004234 7,0.288675135 Z",
    id: "Polygon-Copy-24",
    fill: "#9A0002",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniOrderUnassigned);
export default __webpack_public_path__ + "static/media/mini-order-unassigned.b80eaf1ddeb5adf923475b3884733591.svg";
export { ForwardRef as ReactComponent };